export const anchorListsAreEqual = (initialAnchors, newAnchors) => {
  return !initialAnchors.map((anchor, index) => anchor.x === newAnchors[index].x && anchor.y === newAnchors[index].y).includes(false)
}
